/* @flow */
import AdminAutoMessageSftpCredentialsModal from './AdminAutoMessageSftpCredentialsModal';

export const sftpCredentialsMock = {
  displayName: 'SIS Credentials 1',
  messages: [
    {
      uuid: '123-123',
      messageName: 'Attendance',
    },
    {
      uuid: '321-321',
      messageName: 'Lunch money',
    },
  ],
  credentials: {
    username: 'strong-user-231',
  },
};

export default AdminAutoMessageSftpCredentialsModal;
